export enum StaticPages {
  CONTACT = 'contact',
  SERVICES = 'services',
  PRICELIST = 'pricelist',
  RESERVATION_POLICY = 'reservationPolicy',
  PRIVACY_POLICY = 'privacyPolicy',
}
